(function () {

    'use strict';

    function definition(enums, App, Backbone, Marionette, $, _) {

        function confirmSubmission(view) {
            view.ui.closeButton.addClass('btn-primary');
            view.ui.requiredMsg.slideUp();
            view.ui.heading.slideUp();
            view.ui.submissionConfirmation.slideDown(500);
        }

        function hideHeadingAndShowError(view) {
            view.ui.heading.slideUp();
            view.ui.error.slideDown(500);
        }

        enums.stageDetails = {
            'contactForm': {
                submissionSuccessBehavior: function (view) {
                    view.ui.form.slideUp(500);
                    view.ui.submitButton.slideUp();
                    confirmSubmission(view);
                },
                submissionErrorBehavior: function (view) {
                    view.ui.requiredMsg.slideUp();
                    view.ui.form.slideUp(500);
                    view.ui.submitButton.slideUp();
                    view.ui.closeButton.addClass('btn-primary');
                    hideHeadingAndShowError(view);
                },
                modalHiddenBehavior: function (view) {
                    view.ui.submissionConfirmation.slideUp();
                }
            },
            'scheduling': {
                modalHiddenBehavior: function (view) {
                    view.ui.scheduling.slideUp();
                    view.ui.footer.slideDown();

                    RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.ExitedModalAtSchedulingStage);

                    // NOTE the form info has already been validated, so there's no
                    // need to validate again; just submit
                    view.formSubmit();
                },
                transitionToBehavior: function (view) {

                    // confirm that the form is valid before transitioning
                    if (view.validate()) {

                        view.schedulingStage = 'scheduling';

                        view.ui.form.slideUp(500);
                        view.ui.requiredMsg.slideUp();
                        view.ui.footer.slideUp();
                        view.ui.heading.slideUp();

                        // prepare Calendly link
                        const CALENDLY_BASE_URL = 'https://calendly.com/rival-iq/30min-demo';
                        const encodedParams = encodeURI(`name=${view.ui.firstName.val()} ${view.ui.lastName.val()}&email=${view.ui.email.val()}`);
                        const calendlyUrlWithParams = `${CALENDLY_BASE_URL}?${encodedParams}`;
                        $('#calendlyButton').attr('href', calendlyUrlWithParams);

                        view.ui.scheduling.slideDown(500);

                        RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.GotToSchedulingStage);
                    }
                },
                schedulingMethod: {
                    name: 'scheduling',
                    description: 'No method chosen'
                }
            },
            'calendly': {
                submissionSuccessBehavior: function (view) {
                    view.ui.closeButton.slideDown();
                    view.ui.scheduleButton.slideUp();
                    view.ui.footer.slideDown();
                    confirmSubmission(view);
                },
                submissionErrorBehavior: function (view) {
                    view.ui.submissionConfirmation.slideUp();
                    view.ui.scheduleButton.slideUp();
                    view.ui.closeButton.addClass('btn-primary');
                    view.ui.footer.slideDown();
                    hideHeadingAndShowError(view);
                },
                modalHiddenBehavior: function (view) {
                    view.ui.submissionConfirmation.slideUp();
                    view.ui.footer.slideDown();
                },
                transitionToBehavior: function (view) {
                    view.ui.scheduling.slideUp(500);
                    view.ui.submissionConfirmation.slideDown(500);
                    RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.ChoseSchedulingMethodCalendly);
                    view.formSubmit();
                },
                schedulingMethod: {
                    name: 'calendly',
                    description: 'Calendly'
                }
            },
            'justContactMe': {
                submissionSuccessBehavior: function (view) {
                    view.ui.closeButton.addClass('btn-primary');
                    view.ui.closeButton.show();
                    view.ui.submissionConfirmation.slideDown(500);
                    view.ui.footer.slideDown();
                },
                submissionErrorBehavior: function (view) {
                    view.ui.closeButton.addClass('btn-primary');
                    view.ui.footer.slideDown();
                    hideHeadingAndShowError(view);
                },
                modalHiddenBehavior: function (view) {
                    view.ui.submissionConfirmation.slideUp();
                    view.ui.footer.slideDown();
                },
                transitionToBehavior: function (view) {
                    view.ui.scheduleButton.hide();
                    view.ui.scheduling.slideUp(500);
                    RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.ChoseSchedulingMethodJustContactMe);
                    view.formSubmit();
                },
                schedulingMethod: {
                    name: 'justContactMe',
                    description: 'Please Contact Me'
                }
            }
        };
    }

    const App = (typeof RivalIQ !== 'undefined' ? window.RivalIQ.apps.Site : {
        enums: {}
    });


    if (typeof window === 'undefined') {

        definition(App.enums, App);
        module.exports = App.enums.stageDetails;
    } else {

        App.module('enums', definition);
    }
})();
